import {
  Component,
  ChangeDetectionStrategy,
  Input,
  TemplateRef,
  QueryList,
  ViewChildren,
  AfterContentInit
} from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/distinctUntilChanged';

import { SkyLinkRecordsState, SkyLinkRecordsStateDispatcher } from './state';
import {
  SkyLinkRecordsMatchesSetStatusAction,
  SkyLinkRecordsMatchesSetItemAction

} from './state/matches/actions';
import {
  SkyLinkRecordsFieldsClearFieldsAction,
  SkyLinkRecordsFieldsSetFieldsAction
} from './state/fields/actions';
import {
  SkyLinkRecordsSelectedClearSelectedAction,
  SkyLinkRecordsSelectedSetSelectedAction
} from './state/selected/actions';
import { SKY_LINK_RECORDS_STATUSES } from './link-records-statuses';
import { SkyLinkRecordsItemModel } from './link-records-item.model';
import {
  SkyLinkRecordsItemDiffComponent
} from './link-records-item-diff.component';
import { SkyLinkRecordsFieldModel } from './state/fields/field.model';


export class SkyLinkRecordsItemComponent implements AfterContentInit {
  public STATUSES = SKY_LINK_RECORDS_STATUSES;
   public record: SkyLinkRecordsItemModel;
   public itemTemplate: TemplateRef<any>;
   public matchTemplate: TemplateRef<any>;
   public noMatchTemplate: TemplateRef<any>;
   public itemTitleTemplate: TemplateRef<any>;
   public selectedByDefault: boolean;
   public showNewFieldValues: boolean;
  
    public viewItems: QueryList<SkyLinkRecordsItemDiffComponent>;

  /* istanbul ignore next */
  constructor(
    private state: SkyLinkRecordsState,
    private dispatcher: SkyLinkRecordsStateDispatcher
  ) {}

  public ngAfterContentInit() {
    if (this.record.status === this.STATUSES.Edit &&
      (!this.record.matchFields || this.record.matchFields.length === 0)) {
      this.link();
    }
  }

  get updatedFieldsTotal(): Observable<number> {
    return this.state
      .map(s => s.selected.item[this.record.key] || {})
      .map(fields => Object.keys(fields).filter(k => fields[k]).length)
      .distinctUntilChanged();
  }

  public link() {
    this.dispatcher.next(
      new SkyLinkRecordsMatchesSetStatusAction(this.record.key, this.STATUSES.Linked)
    );
  }

  public unlink() {
    this.dispatcher.next(
      new SkyLinkRecordsMatchesSetStatusAction(this.record.key, this.STATUSES.NoMatch)
    );
    this.dispatcher.next(new SkyLinkRecordsMatchesSetItemAction(this.record.key, undefined));
    this.dispatcher.next(new SkyLinkRecordsSelectedClearSelectedAction(this.record.key));
    this.dispatcher.next(new SkyLinkRecordsFieldsClearFieldsAction(this.record.key));
  }

  public create() {
    this.dispatcher.next(
      new SkyLinkRecordsMatchesSetStatusAction(this.record.key, this.STATUSES.Created)
    );
    this.dispatcher.next(new SkyLinkRecordsMatchesSetItemAction(this.record.key, this.record.item));
  }

  public edit() {
    let filteredMatchFields: Array<any> = [];

    if (this.record.match.item) {
      // filter possible match fields to show fields between item and item match with different values
      filteredMatchFields = Object.keys(this.record.match.item)
        .filter(id => this.record.item.hasOwnProperty(id)
          && this.record.match.item.hasOwnProperty(id)
          && this.record.matchFields.findIndex(f => f.key === id) > -1
          && (this.record.item[id] && this.record.item[id].toString().trim().length > 0)
          && this.record.item[id] !== this.record.match.item[id]).map(id => {
          let field = this.record.matchFields.find(f => f.key === id);
          return new SkyLinkRecordsFieldModel({
            key: id,
            label: field && field.label && field.label.trim().length > 0 ? field.label : id,
            currentValue: this.record.match.item[id],
            newValue: this.record.item[id]
          });
        });
    }

    if (filteredMatchFields.length === 0) { // if all fields match, link
      this.dispatcher.next(new SkyLinkRecordsMatchesSetStatusAction(this.record.key, this.STATUSES.Linked));
    } else if (!this.showNewFieldValues && filteredMatchFields.every(match =>
          !match.currentValue && match.newValue && match.newValue.length > 0)
    ) { // if we are not showing new values, and all values are new, link
      this.dispatcher.next(
        new SkyLinkRecordsMatchesSetStatusAction(this.record.key, this.STATUSES.Linked)
      );
    } else { // else the status is an edit
      this.dispatcher.next(
        new SkyLinkRecordsMatchesSetStatusAction(this.record.key, this.STATUSES.Edit)
      );
    }

    this.dispatcher.next(new SkyLinkRecordsFieldsSetFieldsAction(this.record.key, filteredMatchFields));

    if (filteredMatchFields.length > 0) {
      this.state.map((s: any) => s.selected.item)
        .filter((s: any) => this.selectedByDefault !== undefined)
        .take(1)
        .subscribe((selected: any) => {
          filteredMatchFields.forEach(matchField => {
            if (selected[this.record.key] && selected[this.record.key].hasOwnProperty(matchField.key)) {
              return;
            }

            if (typeof this.selectedByDefault === 'string') {
              this.selectedByDefault = String(this.selectedByDefault) === 'true';
            }

            this.dispatcher.next(new SkyLinkRecordsSelectedSetSelectedAction(
              this.record.key,
              matchField.key,
              this.selectedByDefault
            ));
          });
        });
    }
  }

  public cancelEdit() {
    this.dispatcher.next(
      new SkyLinkRecordsMatchesSetStatusAction(this.record.key, this.STATUSES.Suggested));
    this.dispatcher.next(new SkyLinkRecordsSelectedClearSelectedAction(this.record.key));
    this.dispatcher.next(new SkyLinkRecordsFieldsClearFieldsAction(this.record.key));
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'sky-link-records-item',
    template: `<div *ngIf="record.status == STATUSES.Suggested || record.status == STATUSES.Selected" class="link-records-item-info">
  {{'link_records_item_info_match' | skyResources}}
</div>
<div *ngIf="record.status == STATUSES.Linked" class="link-records-item-info">
  {{'link_records_item_info_linked' | skyResources}}
</div>
<div *ngIf="record.status == STATUSES.NoMatch" class="link-records-item-info">
  {{'link_records_item_info_no_match' | skyResources}}
</div>
<div *ngIf="record.status == STATUSES.Created" class="link-records-item-info">
  {{'link_records_item_info_created' | skyResources}}
</div>
<div *ngIf="record.status == STATUSES.Edit" class="link-records-item-info">
  {{'link_records_item_info_edit' | skyResources}}
</div>
<div class="link-records-item">
  <div class="link-records-item-original sky-shadow">
    <div class="link-records-item-header">
      <sky-link-records-renderer [item]="record.item" [match]="record.match" [fields]="record.matchFields" [template]="itemTitleTemplate || defaultItemTitleTemplate"></sky-link-records-renderer>
    </div>
    <sky-link-records-renderer *ngIf="record.status != STATUSES.Edit" class="link-records-item-content" [item]="record.item" [match]="record.match" [fields]="record.matchFields" [template]="itemTemplate || defaultItemTemplate"></sky-link-records-renderer>
    <sky-link-records-item-diff *ngIf="record.status == STATUSES.Edit" [key]="record.key" [item]="record.item" [match]="record.match" [fields]="record.matchFields" [readOnly]="true"  [showNewFieldValues]="showNewFieldValues" class="link-records-item-content">
    </sky-link-records-item-diff>
    <div class="link-records-item-footer"></div>
  </div>
  <div class="link-records-item-status">
    <div class="link-records-item-status-content"><i class="fa"
      [class.fa-check]="record.status == STATUSES.Linked"
      [class.fa-pencil]="record.status == STATUSES.Edit"
      [class.fa-plus-circle]="record.status == STATUSES.Created"
      [class.fa-question-circle]="record.status == STATUSES.Suggested || record.status == STATUSES.NoMatch || record.status == STATUSES.Selected"
    ></i></div>
  </div>
  <div class="link-records-item-match sky-shadow">
    <div class="link-records-item-header">
      <div *ngIf="record.status == STATUSES.Created">
          {{'link_records_item_header_created' | skyResources}}
      </div>
      <div *ngIf="record.status == STATUSES.NoMatch">
          {{'link_records_item_header_no_match' | skyResources}}
      </div>
      <div *ngIf="record.status == STATUSES.Suggested || record.status == STATUSES.Selected || record.status == STATUSES.Linked || record.status == STATUSES.Edit">
          {{'link_records_item_header_match' | skyResources}}
      </div>
    </div>
    <sky-link-records-renderer *ngIf="record.status != STATUSES.Edit && record.status != STATUSES.NoMatch && record.status != STATUSES.Selected" class="link-records-item-content" [item]="record.item" [match]="record.match" [fields]="record.matchFields" [template]="matchTemplate || defaultMatchTemplateContent"></sky-link-records-renderer>
    <sky-link-records-renderer *ngIf="record.status == STATUSES.NoMatch || record.status == STATUSES.Selected" class="link-records-item-content" [item]="record.item" [match]="record.match" [fields]="record.matchFields" [template]="noMatchTemplate || defaultNoMatchTemplateContent"></sky-link-records-renderer>
    <sky-link-records-item-diff *ngIf="record.status == STATUSES.Edit" [key]="record.key" [item]="record.item" [match]="record.match" [fields]="record.matchFields" [selectedByDefault]="selectedByDefault" [showNewFieldValues]="showNewFieldValues" class="link-records-item-content"></sky-link-records-item-diff>
    <div class="link-records-item-footer">
      <button *ngIf="record.status == STATUSES.Suggested || record.status == STATUSES.Selected" (click)="edit()" class="sky-btn sky-btn-primary">
          {{'link_records_item_footer_link' | skyResources}}
      </button>
      <button *ngIf="record.status == STATUSES.Suggested || record.status == STATUSES.Selected" (click)="unlink()" class="sky-btn sky-btn-default">
          {{'link_records_item_footer_search' | skyResources}}
      </button>
      <button *ngIf="record.status == STATUSES.Linked || record.status == STATUSES.Created" (click)="unlink()" class="sky-btn sky-btn-link">
          {{'link_records_item_footer_unlink' | skyResources}}
      </button>
      <button *ngIf="record.status == STATUSES.NoMatch" (click)="create()" class="sky-btn sky-btn-default">
          {{'link_records_item_footer_create' | skyResources}}
      </button>
      <button *ngIf="record.status == STATUSES.Edit" (click)="link()" class="sky-btn sky-btn-primary">
        {{ (updatedFieldsTotal | async) > 0 ? ('link_records_item_footer_link_with_updating' | skyResources) + ' (' + (updatedFieldsTotal | async) + ')' : ('link_records_item_footer_link_without_updating' | skyResources) }}
      </button>
      <button *ngIf="record.status == STATUSES.Edit" (click)="cancelEdit()" class="sky-btn sky-btn-link">
          {{'link_records_item_footer_cancel' | skyResources}}
      </button>
    </div>
  </div>
</div>

<ng-template #defaultItemTitleTemplate let-item="item">
  {{'link_records_item_title_default' | skyResources}}
</ng-template>
<ng-template #defaultItemTemplate let-item="item">
  {{ item?.id }}
</ng-template>
<ng-template #defaultMatchTemplateContent let-match="match">
  {{ match?.item?.id}}
</ng-template>
<ng-template #defaultNoMatchTemplateContent let-match="match">
    {{'link_records_item_content_no_match' | skyResources}}
</ng-template>
`,
    styles: [`.sky-btn {
  background-color: transparent;
  border-top: 1px solid #cdcfd2;
  border-bottom: 1px solid #cdcfd2;
  border-left: 1px solid #cdcfd2;
  border-right: 1px solid #cdcfd2;
  border-radius: 3px;
  color: #282b31;
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  padding: 6px 12px;
  line-height: 1.42857;
  font-size: 15px;
}

.sky-btn:hover {
  border-top: 1px solid #e2e3e4;
  border-bottom: 1px solid #e2e3e4;
  border-left: 1px solid #e2e3e4;
  border-right: 1px solid #e2e3e4;
  color: #282b31;
}

.sky-btn.sky-btn-disabled, .sky-btn[disabled] {
  cursor: not-allowed;
  pointer-events: none;
  opacity: .65;
  box-shadow: none;
}

.sky-btn-default {
  color: #282b31;
  background-color: #ffffff;
  border-color: #cdcfd2;
}

.sky-btn-default:hover, .sky-btn-default:active, .sky-btn-default.sky-btn-active {
  color: #282b31;
  background-color: #eeeeef;
  border-color: #b2b5ba;
}

.sky-btn-default:active, .sky-btn-default.sky-btn-active {
  background-image: none;
}

.sky-btn-default.sky-btn-disabled, .sky-btn-default.sky-btn-disabled:hover, .sky-btn-default.sky-btn-disabled:focus, .sky-btn-default.sky-btn-disabled.sky-btn-focus, .sky-btn-default.sky-btn-disabled:active, .sky-btn-default.sky-btn-disabled.sky-btn-active, .sky-btn-default[disabled], .sky-btn-default[disabled]:hover, .sky-btn-default[disabled]:focus, .sky-btn-default[disabled].sky-btn-focus, .sky-btn-default[disabled]:active, .sky-btn-default[disabled].sky-btn-active,
fieldset[disabled] .sky-btn-default,
fieldset[disabled] .sky-btn-default:hover,
fieldset[disabled] .sky-btn-default:focus,
fieldset[disabled] .sky-btn-default.sky-btn-focus,
fieldset[disabled] .sky-btn-default:active,
fieldset[disabled] .sky-btn-default.sky-btn-active {
  background-color: #ffffff;
  border-color: #cdcfd2;
}

.sky-btn-primary {
  color: #ffffff;
  background-color: #007ca6;
  border-color: #007ca6;
}

.sky-btn-primary:hover, .sky-btn-primary:active, .sky-btn-primary.sky-btn-active {
  color: #ffffff;
  background-color: #005673;
  border-color: #005673;
}

.sky-btn-primary:active, .sky-btn-primary.sky-btn-active {
  background-image: none;
}

.sky-btn-primary.sky-btn-disabled, .sky-btn-primary.sky-btn-disabled:hover, .sky-btn-primary.sky-btn-disabled:focus, .sky-btn-primary.sky-btn-disabled.sky-btn-focus, .sky-btn-primary.sky-btn-disabled:active, .sky-btn-primary.sky-btn-disabled.sky-btn-active, .sky-btn-primary[disabled], .sky-btn-primary[disabled]:hover, .sky-btn-primary[disabled]:focus, .sky-btn-primary[disabled].sky-btn-focus, .sky-btn-primary[disabled]:active, .sky-btn-primary[disabled].sky-btn-active,
fieldset[disabled] .sky-btn-primary,
fieldset[disabled] .sky-btn-primary:hover,
fieldset[disabled] .sky-btn-primary:focus,
fieldset[disabled] .sky-btn-primary.sky-btn-focus,
fieldset[disabled] .sky-btn-primary:active,
fieldset[disabled] .sky-btn-primary.sky-btn-active {
  background-color: #007ca6;
  border-color: #007ca6;
}

.sky-btn-link, .sky-btn-link-inline {
  color: #007ca6;
  background-color: transparent;
  border-color: transparent;
}

.sky-btn-link:hover, .sky-btn-link-inline:hover {
  color: #005673;
  background-color: transparent;
  border-color: transparent;
  text-decoration: underline;
  outline: none;
}

.sky-btn-link-inline {
  font-size: inherit;
  line-height: inherit;
  display: inline;
  padding: 0;
  border: none;
  vertical-align: top;
}

.sky-btn-link-inline:hover {
  border: none;
}

.sky-btn-sm {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.sky-btn.sky-btn-active {
  outline: 0;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.sky-btn-tab {
  background-color: transparent;
  border: none;
  border-radius: 4px 4px 0 0;
  color: #686c73;
  cursor: pointer;
  display: inline-block;
  font-weight: 600;
  line-height: 1.8;
  padding: 8px 16px;
}

.sky-btn-tab:hover {
  background-color: #eeeeef;
  color: #282b31;
  text-decoration: none;
}

.sky-btn-tab-close {
  background-color: transparent;
  border: none;
  color: #686c73;
  cursor: pointer;
  line-height: 1.4;
  margin-left: 5px;
}

.sky-btn-tab-close:hover {
  color: #282b31;
  transition: color 150ms;
}

.sky-tab-header-count {
  font-weight: 400;
  color: #007ca6;
  margin-left: 5px;
}

.sky-btn-tab-selected {
  background-color: #007ca6;
  color: #fff;
}

.sky-btn-tab-selected:hover {
  background-color: #007ca6;
  color: #fff;
}

.sky-btn-tab-selected .sky-btn-tab-close, .sky-btn-tab-selected .sky-tab-header-count {
  color: #fff;
}

.sky-btn-tab-wizard {
  background-color: #ffffff;
  border-top: 1px solid #e2e3e4;
  border-bottom: 1px solid #e2e3e4;
  border-left: 1px solid #e2e3e4;
  border-right: 1px solid #e2e3e4;
  border-radius: 3px;
  font-weight: 400;
  color: #282b31;
  line-height: 1.6em;
  margin-right: 5px;
  padding-bottom: 5px;
  padding-top: 5px;
}

.sky-btn-tab-wizard:hover, .sky-btn-tab-wizard:focus {
  text-decoration: none;
  color: #282b31;
  background-color: #eeeeef;
}

.sky-btn-tab-wizard.sky-btn-tab-selected {
  background-color: #81d4f7;
  border-color: #81d4f7;
  color: #282b31;
}

.sky-btn-tab-wizard.sky-btn-tab-disabled {
  cursor: not-allowed;
  pointer-events: none;
  background-color: #eeeeef;
  color: #686c73;
  box-shadow: none;
}

:host {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 710px;
}

:host .link-records-item-info {
  font-family: "Blackbaud Sans", "Helvetica Neue", Arial, sans-serif;
  color: #282b31;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
}

:host .link-records-item {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  margin: 10px 0 40px;
}

:host .link-records-item-original,
:host .link-records-item-match {
  border-top: 1px solid #e2e3e4;
  border-bottom: 1px solid #e2e3e4;
  border-right: 1px solid #e2e3e4;
  border-left: 1px solid #e2e3e4;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  min-height: 200px;
  width: 350px;
}

:host .link-records-item-original .link-records-item-content,
:host .link-records-item-match .link-records-item-content {
  flex-grow: 1;
  padding: 10px 20px 10px 25px;
  word-break: break-all;
}

:host .link-records-item-original .link-records-item-header,
:host .link-records-item-original .link-records-item-footer,
:host .link-records-item-match .link-records-item-header,
:host .link-records-item-match .link-records-item-footer {
  display: flex;
  flex-direction: row;
  min-height: 48px;
}

:host .link-records-item-original .link-records-item-header,
:host .link-records-item-match .link-records-item-header {
  border-bottom: 1px solid #e2e3e4;
  font-family: "Blackbaud Sans", "Helvetica Neue", Arial, sans-serif;
  color: #686c73;
  font-weight: 300;
  font-size: 19px;
  padding: 10px;
}

:host .link-records-item-original .link-records-item-footer,
:host .link-records-item-match .link-records-item-footer {
  border-top: 1px solid #e2e3e4;
  padding: 7px 10px;
}

:host .link-records-item-original .link-records-item-footer button.sky-btn:not(:first-child),
:host .link-records-item-match .link-records-item-footer button.sky-btn:not(:first-child) {
  margin-left: 10px;
}

:host .link-records-item-original .link-records-item-footer button.sky-btn.sky-btn-link, :host .link-records-item-original .link-records-item-footer button.sky-btn.sky-btn-link-inline,
:host .link-records-item-match .link-records-item-footer button.sky-btn.sky-btn-link,
:host .link-records-item-match .link-records-item-footer button.sky-btn.sky-btn-link-inline {
  margin-left: 0;
}

:host .link-records-item-original .link-records-item-footer button.sky-btn.sky-btn-link:first-child, :host .link-records-item-original .link-records-item-footer button.sky-btn.sky-btn-link-inline:first-child,
:host .link-records-item-match .link-records-item-footer button.sky-btn.sky-btn-link:first-child,
:host .link-records-item-match .link-records-item-footer button.sky-btn.sky-btn-link-inline:first-child {
  margin-left: -10px;
}

:host .link-records-item-status {
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
}

:host .link-records-item-status-content {
  border-top: 1px solid #e2e3e4;
  border-bottom: 1px solid #e2e3e4;
  border-right: 1px solid #e2e3e4;
  border-left: 1px solid #e2e3e4;
  background-color: #ffffff;
  border-radius: 22px;
  height: 45px;
  margin: -18px;
  text-align: center;
  width: 45px;
  z-index: 1;
}

:host .link-records-item-status-content i {
  color: #71bf43;
  font-size: 29px;
  margin: 7px 0 0;
}

:host .link-records-item-status-content i.fa-question-circle, :host .link-records-item-status-content i.fa-pencil {
  color: #fbb034;
}

@media (max-width: 768px) {
  :host {
    width: 350px;
  }
  :host .link-records-item {
    flex-direction: column;
  }
}
`],
    changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyLinkRecordsState, },
{type: SkyLinkRecordsStateDispatcher, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'record': [{ type: Input },],
'itemTemplate': [{ type: Input },],
'matchTemplate': [{ type: Input },],
'noMatchTemplate': [{ type: Input },],
'itemTitleTemplate': [{ type: Input },],
'selectedByDefault': [{ type: Input },],
'showNewFieldValues': [{ type: Input },],
'viewItems': [{ type: ViewChildren, args: [SkyLinkRecordsItemDiffComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
